// Copyright (c) 2019 Comsearch, Inc., All rights reserved

/* global USER_POOL */

const userPoolHash = {
  DEV: {
    apiRoot: 'https://l6kqe47080.execute-api.us-east-1.amazonaws.com/dev',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_hL4BZXLY3',
      userPoolWebClientId: '3pjbakb7u687vahn9mac7ga01',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
    trackingConfig: {
      debug: true,
      gaOptions: {
        cookieDomain: 'auto',
      },
    },
    trackingId: 'UA-144784447-1',
    measurementId: 'G-7L55WM7VG1',
  },

  QA: {
    apiRoot: 'https://vv09vv1sq8.execute-api.us-east-1.amazonaws.com/qa',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_hL4BZXLY3',
      userPoolWebClientId: '3pjbakb7u687vahn9mac7ga01',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
    trackingConfig: {
      debug: true,
      gaOptions: {
        cookieDomain: 'auto',
      },
    },
    trackingId: 'UA-144784447-1',
    measurementId: 'G-7L55WM7VG1',
  },

  PROD: {
    apiRoot: 'https://frh3yreglj.execute-api.us-east-1.amazonaws.com/prod',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_oHH1SM4yi',
      userPoolWebClientId: '36j9kp01fuel9sa55g5ao5sbm6',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
    trackingConfig: {
      debug: false,
      gaOptions: {
        cookieDomain: 'auto',
      },
    },
    trackingId: 'UA-137023296-1',
    measurementId: 'G-CCPKT197BF',
  },

  PRODEVEN: {
    apiRoot: 'https://6dh4mottog.execute-api.us-east-1.amazonaws.com/prodeven',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_oHH1SM4yi',
      userPoolWebClientId: '36j9kp01fuel9sa55g5ao5sbm6',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
    trackingConfig: {
      debug: false,
      gaOptions: {
        cookieDomain: 'auto',
      },
    },
    trackingId: 'UA-137023296-1',
    measurementId: 'G-CCPKT197BF',
  },

  PRODODD: {
    apiRoot: '<prododd url>',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_oHH1SM4yi',
      userPoolWebClientId: '36j9kp01fuel9sa55g5ao5sbm6',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
    trackingConfig: {
      debug: false,
      gaOptions: {
        cookieDomain: 'auto',
      },
    },
    trackingId: 'UA-137023296-1',
    measurementId: 'G-CCPKT197BF',
  },

  UAT: {
    apiRoot: 'https://8mm27vrqy2.execute-api.us-east-1.amazonaws.com/uat',
    Auth: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_hL4BZXLY3',
      userPoolWebClientId: '3pjbakb7u687vahn9mac7ga01',
      mandatorySignIn: true,
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
    trackingConfig: {
      debug: false,
      gaOptions: {
        cookieDomain: 'auto',
      },
    },
    trackingId: 'UA-144784447-1',
    measurementId: 'G-7L55WM7VG1',
  },
}

// pulls out the mapped api root and Auth config
const {
  apiRoot,
  Auth,
  measurementId,
  trackingConfig,
  trackingId,
} = userPoolHash[USER_POOL]

// and exposes only these
export {
  apiRoot,
  Auth,
  measurementId,
  trackingConfig,
  trackingId,
}
